module.exports = __webpack_public_path__ + "static/img/log.19b2f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/log.png
// module id = GDz2
// module chunks = 1